var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "va-row calcendarWrapper",
      attrs: { id: "calcendarWrapper" },
    },
    [
      _c(
        "div",
        { staticClass: "flex md8 xs12" },
        [
          _c("FullCalendar", {
            ref: "fullCalendar",
            staticClass: "calcendarWrapper-calendar",
            attrs: {
              defaultView: "dayGridMonth",
              defaultDate: "2019-10-18",
              header: {
                left: "prev",
                center: "title",
                right: "next",
              },
              plugins: _vm.calendarPlugins,
              weekends: true,
              selectable: true,
              editable: false,
              droppable: false,
              events: _vm.calendarEvents,
            },
            on: { dateClick: _vm.handleDateClick },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex md4 xs12" },
        [
          _c(
            "vuestic-card",
            { staticClass: "result", attrs: { stripe: "success" } },
            [
              _c(
                "p",
                { attrs: { slot: "title" }, slot: "title" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("newSettlement.totalBalance")) +
                      "\n        "
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "Order amount, including fees.",
                        placement: "top",
                        effect: "light",
                        "popper-class": "vue-tips",
                      },
                    },
                    [
                      _c("el-button", { staticClass: "btn-unblock" }, [
                        _c("span", {
                          staticClass: "entypo entypo-help wenhao",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.totalMoney, function (value, key) {
                return _c(
                  "ul",
                  {
                    staticClass: "well",
                    staticStyle: {
                      "max-width": "max-content",
                      padding: "16px",
                    },
                    attrs: { id: "total_balance" },
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "item-money",
                        staticStyle: { "list-style-type": "none" },
                      },
                      [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "16px" } },
                          [_vm._v(_vm._s(key))]
                        ),
                        _c("span", { staticStyle: { float: "right" } }, [
                          _vm._v(_vm._s(_vm.formatAmount(value))),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              _c("div", { staticClass: "card-separator" }),
              _c("h5", { staticClass: "vuestic-card__title card-title" }, [
                _c("p", {}, [
                  _vm._v(_vm._s(_vm.$t("newSettlement.settlementAmount"))),
                ]),
              ]),
              Object.keys(_vm.selectedDealData).length === 0
                ? _c(
                    "ul",
                    {
                      staticClass: "well",
                      staticStyle: {
                        "min-width": "20px",
                        "max-width": "max-content",
                        padding: "16px",
                      },
                      attrs: { id: "settlementAmount" },
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass: "item-money",
                          staticStyle: { "list-style-type": "none" },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "16px" } },
                            [_vm._v(" ")]
                          ),
                          _c("span", { staticStyle: { float: "right" } }, [
                            _vm._v(" "),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._l(_vm.selectedDealData, function (item, i) {
                    return _c(
                      "ul",
                      {
                        staticClass: "well",
                        staticStyle: {
                          "min-width": "20px",
                          "max-width": "max-content",
                          padding: "16px",
                        },
                        attrs: { id: "settlementAmount" },
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass: "item-money",
                            staticStyle: { "list-style-type": "none" },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "16px" } },
                              [_vm._v(_vm._s(i))]
                            ),
                            _c("span", { staticStyle: { float: "right" } }, [
                              _vm._v(_vm._s(_vm.formatAmount(item))),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
              _c("p", { staticClass: "pt-3 mb-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm",
                    on: { click: _vm.updateNewDeal },
                  },
                  [_vm._v(_vm._s(_vm.$t("basic.button.confirm")))]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary focus btn-sm",
          attrs: { id: "backParent" },
          on: { click: _vm.goBack },
        },
        [_vm._v(_vm._s(_vm.$t("back")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }